module.exports = __webpack_public_path__ + "img/AHK3.png";